import { useMemo } from 'react';
import type { AppliedFilters } from '~/contracts/common';
import useGetRecommendedVehicles from '~/hooks/home/services/useGetRecommendedVehicles';
import useGetMostViewedOrMostRecentYMM from './useGetMostViewedOrMostRecentYMM';

export default function useGetUpgradeYourRideVehicles() {
  const { vehicleId, price } = useGetMostViewedOrMostRecentYMM() ?? {};
  const { total = 0 } = price || {};
  const filters = useMemo<Partial<AppliedFilters>>(
    () => ({
      price: {
        min: Math.floor(total * 1.1) // Find slightly more expensive vehicle
      }
    }),
    [total]
  );

  return useGetRecommendedVehicles(12, filters, vehicleId);
}
